import React from 'react';

export const FacebookLogo = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#EAF3EF" />
    <path
      d="M23.941 21.0485L24.4369 17.8155H21.335V15.7176C21.335 14.8331 21.7683 13.9709 23.1577 13.9709H24.568V11.2184C24.568 11.2184 23.2881 11 22.0643 11C19.5096 11 17.8398 12.5483 17.8398 15.3515V17.8155H15V21.0485H17.8398V28.8641C18.4093 28.9535 18.9928 29 19.5874 29C20.182 29 20.7655 28.9535 21.335 28.8641V21.0485H23.941Z"
      fill="#343435"
    />
  </svg>
);
